import { toIndianCurrencyHeader } from "../../../MethodMaster/JSXComponentMothod";
import "../DashboardUnique.css";

export default function GrantYojnaDetailHeader({ yojna, handleNavigateToMainTab }) {
  console.log(yojna, "yojnayojna");
  return (
    <div className={"govdash-yojnaDetailHeader"}>
      <div onClick={handleNavigateToMainTab} className={"govdash-detailIconWrapper cursor-pointer"}>
        <i className={`${yojna.IconName} ${"govdash-detailIcon"}`}></i>
      </div>
      <div className={"govdash-detailInfo"}>
        <h2 className={"govdash-detailName"}>{yojna.GrantYojnaName}</h2>
        <div className={"govdash-detailStats"}>
          <div className={"govdash-statItem"}>
            <span className={"govdash-statLabel"}>Village Count</span>
            <span className={"govdash-statValue"}>{yojna.VillageCount?.toLocaleString()}</span>
          </div>
          {!!Number(yojna?.TotalAmount || 0) && (
            <div className={"govdash-statItem"}>
              <span className={"govdash-statLabel"}>Amount</span>
              <span className={"govdash-statValue"}>
                {yojna?.IsYojanaAmount == 1
                  ? `₹${(parseInt(yojna?.YojanaAmount || 0) * parseInt(yojna?.TotalAmount || 0))?.toLocaleString() || ""}`
                  : `₹${yojna?.TotalAmount?.toLocaleString()}`}
              </span>
              {/* <span className={"govdash-statValue"}> */}
              {yojna?.IsYojanaAmount == 1
                ? toIndianCurrencyHeader(parseFloat(yojna?.YojanaAmount || 0) * parseFloat(yojna?.TotalAmount || 0))
                : toIndianCurrencyHeader(parseFloat(yojna?.TotalAmount || 0))}
              {/* </span> */}
            </div>
          )}

          <div className={"govdash-statItem"}>
            <span className={"govdash-statLabel"}>Status</span>
            <span className={`${"govdash-statusBadge"} ${true ? "govdash-active" : "govdash-inactive"}`}>{true ? "Active" : "Inactive"}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
